module.exports = require("@hapi/joi");